import ResourceModel from "models/convention-api/ResourceModel"
import moment from "moment-timezone"

export default class ConventionTeamMember extends ResourceModel {
  protected static basePath = "/v1/convention_providers/:provider_id/convention_team_members"

  admin_avatar_thumb_url!: null | string
  admin_bio!: null | string
  admin_first_name!: null | string
  admin_last_name!: null | string
  admin_title!: null | string
  created_at!: moment.Moment
  institution_id!: string
  updated_at!: moment.Moment
}
